import { AbstractAdminEntityService } from "./AbstractAdminEntityService";
import { HttpService } from "../http/HttpService";
import { ListResponse, ProviderList} from "../http/protocol";

export class PaymentProviderService extends AbstractAdminEntityService<{}, ListResponse> {
    constructor(http: HttpService) {
        super("/payment-providers", http)
    }

    async listPaymentProviderNames() : Promise<ProviderList> {
        let url = `${this.entityPath}/list`;
        return this.http.get(url);
    }

    async listManualPaymentProviders(): Promise<ProviderList> {
        let url = `${this.entityPath}/list/manual`;
        return this.http.get(url);
    }
    
}